import { render } from "./IStoreSidebarNavRecursive.vue?vue&type=template&id=2cc5383c"
import script from "./IStoreSidebarNavRecursive.vue?vue&type=script&lang=js"
export * from "./IStoreSidebarNavRecursive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__